export default function partitionAtFirst<X = unknown>(
    values: Iterable<X>,
    predicate: (val: X) => boolean
): [X[], X[]] {
    const before: X[] = [];
    const after: X[] = [];
    let afterPred = false;
    for (const val of values) {
        if (!afterPred && predicate(val)) afterPred = true;
        if (afterPred) {
            after.push(val);
        } else {
            before.push(val);
        }
    }

    return [before, after];
}
